import React from "react";
import { Form } from "rsuite";

const LandlordDetails = () => {
  return (
    <div className="grid grid-cols-1 mt-3 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-5">
      <Form.Group>
        <Form.ControlLabel>Landlord/Owner Name</Form.ControlLabel>
        <Form.Control name="Landlord/Owner Name" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Landlord/Owner Address</Form.ControlLabel>
        <Form.Control name="Landlord/Owner Address" />
      </Form.Group>
      <Form.Group>
        <Form.ControlLabel>Landlord/Owner Phone No.</Form.ControlLabel>
        <Form.Control name="Landlord/Owner Phone No." />
      </Form.Group>
    </div>
  );
};

export default LandlordDetails;
